
var Constants = {
	URL_BASE_SERVICES: window.location.origin
};
